import React, { useEffect } from 'react'
import axios from 'ps-components/lib/apiClient';
import { useSelector, useDispatch } from 'react-redux'
import { getMarketplaceMatches, setJobStatus } from '../MarketplaceMatchesActions'
import MarketplaceMatchesGridNew from './MarketplaceMatchesGridNew';
import MarketplaceMatchesSlideoutHeaderActions from './MarketplaceMatchesSlideoutHeaderActions'
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import { getJobPricingDetails } from '../../JobPricing/JobPricingActions';
import { bindActionCreators } from 'redux';
import { jobPricingGridActions } from '../../JobPricingDetails/JobPricingGrid/JobPricingGridCreate';
import { marketplaceMatchesSelector } from './selectors';
import PSPlaceholder from 'ps-components/Placeholder/Placeholder';
import Placeholder from '../../Placeholder/Placeholder';
import addAlert from 'ps-components/AlertToast/addAlert';
import '../MarketplaceMatches.scss';

const MarketplaceMatchesNew: React.FC = () => {
  const { session, matches, displayIn, slideout, slideoutOpen } = useSelector(marketplaceMatchesSelector)
  const { currentJobIndex, showActiveSurveys, selectedJobIds, jobs } = slideout
  const currentJob = jobs[currentJobIndex]
  const jobStatus = currentJob?.status
  const { benchmarkYear, organization } = session
  const dispatch = useDispatch()
  const scrollRef = React.createRef();

  const getMatches = async (jobId: number | string | undefined, benchmarkYear: string | number, showActiveSurveys: boolean) => {
    if (!jobId || !slideoutOpen) return
    try {
      if ((showActiveSurveys && !matches.purchasedLoaded) || (!showActiveSurveys && !matches.unpurchasedLoaded)) {
        const surveyMatchesRes = await (axios as any).apiGet(`/api/market-pricing/job-matches/byJobId?jobId=${jobId}`)
        const resData = surveyMatchesRes.data
        dispatch(setJobStatus(resData.job.status))
        if (resData.job.status === 'priced') {
          dispatch(getMarketplaceMatches(resData.matches, resData.job.currency, showActiveSurveys, true))
          const boundAction = bindActionCreators({ ...jobPricingGridActions }, dispatch)
          if (showActiveSurveys) dispatch(getJobPricingDetails(resData.job, benchmarkYear, displayIn, boundAction.search, organization.masterAccountId))
        }
      }
    } catch (err) {
      console.error(err)
      addAlert('There was an error getting surveys', 'danger');
    }
  }

  useEffect(() => {
    getMatches(currentJob?.jobId, benchmarkYear, showActiveSurveys)
  }, [currentJob?.jobId, benchmarkYear, showActiveSurveys, currentJobIndex, selectedJobIds, matches.purchasedLoaded, matches.unpurchasedLoaded])

  if (!currentJob?.jobId) return null

  return (
    <div className='marketplace-matches'>
      <div className="marketplace-matches__content">
        <div>
          {jobStatus && jobStatus === 'neither' &&
            <div className="marketplace-matches__no-results-container">
              <img className="no-results-img" src="/view/static/mp/images/market_place_matches.svg" />
              <PSPlaceholder
                primaryText="Find Suggested Matches with Marketplace Matches"
                secondaryText="Suggestions are based on how other companies have market priced using the same survey jobs"
                showText={true}
              />
              <div className="marketplace-matches__why">
                <div className="marketplace-matches__why-header">Why do I not see marketplace matches for this job?</div>
                <span className="marketplace-matches__why-body">
                  Either no survey job matches have been made or the current matches do not have any corresponding suggestions.
                  Start adding matches or try different matches to see suggestions.
                </span>
              </div>
            </div>
          }
          {jobStatus && jobStatus === 'slotted' &&
            <Placeholder
              className="pxl-text-small pxl-text-muted"
              primaryText={<span>Marketplace recommendations are not available for Slotted jobs</span>}
            />}
          {jobStatus && jobStatus === 'priced' &&
            <>
              <MarketplaceMatchesSlideoutHeaderActions scrollRef={scrollRef} />
              {matches.loading || !jobs ?
                <div className='mpm-slideout--loading-container'><InPlaceIndicator /></div> :
                <MarketplaceMatchesGridNew />
              }
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default MarketplaceMatchesNew